































import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() reset?: Function;
  @Prop() hideToggle?: boolean;
  @Prop() hiddenExpand?: boolean;
  expand: boolean = false;
  handleToggle() {
    this.expand = !this.expand;
  }
  handleReset() {
    this.reset && this.reset();
  }
}
